// extracted by mini-css-extract-plugin
export default {"gray-60":"rgb(105, 111, 119)","wrapper":"styles_wrapper__vnRQN","heading":"styles_heading__oILnY","secondary":"styles_secondary__qcqQg"};